function testUserAgent(re: RegExp) {
  if (typeof window === 'undefined' || window.navigator == null) {
    return false;
  }
  return re.test(window.navigator.userAgent);
}

export function isIOS() {
  return testUserAgent(/(iPhone|iPod|iPad)/i);
}

export function isAndroid() {
  return testUserAgent(/(android)/i);
}

export function isIpad() {
  return testUserAgent(/(Mac OS)/i) && document.ontouchstart !== undefined;
}

export function isMobile() {
  return isIOS() || isAndroid();
}
